import React from 'react';
import styles from './Loader.module.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function Loader({
  loading,
  error,
  errorText,
  children,
}) {
  if (!loading && !error) return children;

  return <div className={styles.Loader}>
    {
      error && !loading ? <span className={styles.error}>
        <i className={classNames(styles.icon, "fal fa-exclamation-triangle mb-3")}></i>
        <span>{errorText}</span>
      </span> : null
    }
    {
      loading && <i className={classNames(styles.spinner, "fal fa-spinner")}></i>
    }
  </div>;
}

Loader.propTypes = {
  errorText: PropTypes.string,
  error: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  children: PropTypes.node
};

Loader.defaultProps = {
  errorText: 'Sorry, we had trouble loading this for you.',
  error: false,
  loading: false,
  children: null
};

export default Loader;